export const signupSelectUiIsDirty = (state) => state.signup.ui.dirty;
export const signupSelectUiIsLoading = (state) => state.signup.ui.loading !== 0;
export const signupSelectUiIsSaving = (state) => state.signup.ui.saving;
export const signupSelectUiIsVisible = (state) => state.signup.ui.visible;
export const signupSelectUiCancelConfirmationIsVisible = (state) => state.signup.ui.cancelConfirmation.visible;
export const signupSelectGroup = (state) => state.signup.group;
export const signupSelectSenders = (state) => state.signup.senders;
export const signupSelectForm = (state) => state.signup.form;